import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { AnalyticsService } from 'app/shared/analytics/analytics.service';
import { MathtagService } from 'app/shared/analytics/mathtag/mathtag.service';
import { VestibularService } from 'app/vestibular/shared/vestibular.service';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { UploadImagemService } from 'app/shared/upload-imagem/upload-imagem.service';
import { FluxoVestibularService } from '../shared/fluxoVestibular.service';
import { environment } from '../../../../environments/environment';

import { DadosVestibular } from 'models/dados-vestibular';

@Component({
  moduleId: module.id.toString(),
  selector: 'app-dados-pessoais',
  templateUrl: './dados-pessoais.component.html',
  styleUrls: ['./dados-pessoais.component.scss'],
  animations: [routerTransition],
})
export class DadosPessoaisComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  // vars ctrl
  loading = false;
  dadosVestibular: DadosVestibular;
  formData: any;
  idVestibular: any;
  vestibularMedicina: boolean;
  vestibularReingresso: boolean;
  dadosVestibularSubscription: Subscription;
  podeVoltar = true;
  cursosVestibularReingresso: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoVestibularService: FluxoVestibularService,
    private uploadImagemService: UploadImagemService,
    private blockingSpinnerService: BlockingSpinnerService,
    private analytics: AnalyticsService,
    private mathtag: MathtagService,
    private vestibularService: VestibularService,
  ) { }

  ngOnInit() {

    // FIXME: REMOVER, SOMENTE PARA TESTES
    // this.fluxoVestibularService.setPassoAtual(2);
    // this.fluxoVestibularService.setDadosVestibular(DadosVestibularMock);

    //this.limparDadosMarketPlace();


    this.loading = true;
    this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    this.podeVoltar = this.fluxoVestibularService.passoAtualRetornavel();
    if (!this.dadosVestibular.vestibular) {

      this.dadosVestibularSubscription = this.fluxoVestibularService.dadosVestibularMessage$.subscribe(() => {
        this.dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
        this.dadosVestibularSubscription.unsubscribe();
        this.init();
        this.existeCursosReingresso();
        console.log(this.dadosVestibular);
      });

    } else {
      this.init();
      this.analytics.registrar(
        `Vestibular`,
        `Fluxo ${this.dadosVestibular.vestibular.tipo}`,
        'Dados pessoais',
      );
    }
    this.existeCursosReingresso();

  }

  init() {
    const { id, codigo, sigla, tipo, isReingresso, ano } = this.dadosVestibular.vestibular;
    this.idVestibular = id;
    this.vestibularMedicina = sigla === 'ME' || sigla === 'MN';
    this.vestibularReingresso = isReingresso;
    if (this.vestibularReingresso && !this.cursosVestibularReingresso) {
      this.vestibularService.getOpcoesCursos(ano, codigo).then((opcoesCursos) => {
        this.cursosVestibularReingresso = opcoesCursos;
        this.loading = false;
      });
    }

    if (this.dadosVestibular.candidato && this.dadosVestibular.candidato.cpf) {
      this.formData = this.dadosVestibular.candidato;
      this.formData.cursoReingresso = this.dadosVestibular.cursoSelecionado;
    }
    this.loading = false;

    // add reemarketing track
    if (environment.production === 'true' && sigla === 'EA') {
      this.mathtag.inscricaoDadosPessoais();
    }
  }

  ngOnDestroy() {
    // remove script Remarketing
    if (environment.production === 'true' && this.dadosVestibular.vestibular.sigla === 'EA') {
      this.mathtag.removerTodosScripts();
    }
  }

  handleFormSubmit(formData: any) {
    this.loading = true;
    this.formData = formData;
    let dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    this.blockingSpinnerService.show();
    if (this.vestibularMedicina && dadosVestibular.vestibular.sigla!='MN') {

      // upload da foto
      this.uploadImagemService.uploadImagem(
        this.idVestibular.ano,
        this.idVestibular.codigo,
        this.formData.cpf.replace(/[^\d]+/g, ''),
        this.formData.dataImg.image,
        //Vestibular ENEM Medicina
        (this.formData.documentoNotas)? this.formData.documentoNotas:null,
        (this.formData.imagemDocReferencia)? this.formData.imagemDocReferencia:null,
        (this.formData.imagemIdentReferencia)? this.formData.imagemIdentReferencia:null,
        (this.formData.documentoVeracidadeInformacao)? this.formData.documentoVeracidadeInformacao:null
      ).then(
        () => {
          this.saveDadosCandidato();
          this.loading = false;
        },
        err => {
          console.log(err);
          this.loading = false;
          this.blockingSpinnerService.close();
        },
      );
    } else {
      this.saveDadosCandidato();
    }
  }

  handleVoltar(data) {
    this.fluxoVestibularService.voltarPasso();
    const rotaAnterior = this.fluxoVestibularService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  saveDadosCandidato() {
    const dadosVest = {
      candidato: {
        cpf: this.formData.cpf,
        nome: this.formData.nome,
        email: this.formData.email,
        dtNascimento: this.formData.dtNascimento,
        telefone: this.formData.telefone,
        cadastroExistente: this.formData.cadastroExistente,
      },
    };

    if (this.vestibularMedicina) {
      Object.assign(dadosVest.candidato, {
        uf: this.formData.uf,
        cidade: this.formData.cidade,
        rg: this.formData.rg,
        orgexp: this.formData.orgexp,
      });
    }

    if (this.vestibularReingresso) {
      Object.assign(dadosVest, { cursoSelecionado: this.formData.cursoReingresso });
      Object.assign(dadosVest.candidato, {
        cpd: this.formData.cpd,
        cpf: this.formData.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4'),
        dadosCpd: this.formData.dadosCpd,
      });
    }

    //Precisamos buscar a sigla do vestibular para saber se o vestibular é medicina de ENEM
    let dadosVestibular = this.fluxoVestibularService.getDadosVestibular();
    //console.log(dadosVestibular.vestibular.sigla);
    if(dadosVestibular.vestibular.sigla == 'EO' ||
       dadosVestibular.vestibular.sigla == 'AE' ||
       dadosVestibular.vestibular.sigla == 'AEO'){
      Object.assign(dadosVest.candidato, {
        celular: this.formData.celular
      });
    }
    if(dadosVestibular.vestibular.sigla=='MN'){
      Object.assign(dadosVest.candidato, {
        celular: this.formData.celular
      });

      Object.assign(dadosVest, {
        enem:{
          ano: this.formData.ano,
          numeroInscricao: this.formData.numeroInscricaoEnem,
          pontuacaoEnemE1: this.formData.pontuacaoEnemE1,
          pontuacaoEnemE2: this.formData.pontuacaoEnemE2,
          pontuacaoEnemE3: this.formData.pontuacaoEnemE3,
          pontuacaoEnemE4: this.formData.pontuacaoEnemE4,
          pontuacaoEnemRE: this.formData.pontuacaoEnemRE,
        }
      })
    }

    this.fluxoVestibularService.proximoPasso(dadosVest);

    const proximaRota = this.fluxoVestibularService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });

    this.blockingSpinnerService.close();
  }

  limparDadosMarketPlace(){
    if(sessionStorage.getItem("marketPlaceData") != null){
      sessionStorage.setItem("byMarketPlace", "true");
      sessionStorage.setItem("marketPlaceData", null);

    }

  }

  private existeCursosReingresso() {
    if (!this.cursosVestibularReingresso) {
      this.loading = true;
    }
  }
}
